import toNumber from 'lodash/toNumber'
import React from 'react'
import { useAllLocalStorage } from '@ztechapps/common.hook'

export const useOnBoard = ({ storageKey, steps, enabled }: any = {}) => {
  //this is the storage logic, and it should be abstracted
  const keysLength = React.useMemo(() => steps?.length ?? 0, [steps])
  const storage = useAllLocalStorage()
  const [stepIndex, setStepIndex] = React.useState<any>([0, keysLength])
  const [run, setRun] = React.useState(false)

  const _setRun = (run) => {
    if (_stepIndex() === -1) setRun(false)
    else setRun(run)
  }

  //do storage on somewhere, for now, let it be on the local storage
  const goTo = (index) => {
    if (!enabled) return
    _setStepIndex(index)
  }

  const _stepIndex = () => {
    const stepIndex = storage.get(storageKey, true)
    return toNumber(stepIndex?.[0] ?? 0)
  }

  React.useEffect(() => {
    setStepIndex(_stepIndex())
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `_stepIndex` is a plain closure re-created every render (not memoized); it only reads `storage`/`storageKey`, already this effect's real trigger, so listing it would just re-run the effect on every render with no new signal
  }, [storage])

  const _setStepIndex = (index) => {
    const stepIndex = [index, keysLength]

    setStepIndex(index)
    storage.set(storageKey, stepIndex)
  }

  const goNext = () => {
    const index = _stepIndex()

    //do not go next when teh step index is less than zero, it mean it already ended so it should not be updated
    if (index < 0) return

    goTo(index + 1)
  }
  const goBack = () => {
    const index = _stepIndex()
    //do not go next when teh step index is less than zero, it mean it already ended so it should not be updated
    if (index < 0) return

    goTo(index - 1)
  }

  return { stepIndex, setStepIndex: _setStepIndex, goNext, goTo, goBack, steps, storageKey, run, setRun: _setRun }
}
